import * as React from "react";
function SvgMagicWand(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={svgRef}
      {...props}
    >
      <path
        fill="currentColor"
        d="m5 2.7 1.9 1.1-1.1-1.9L6.9 0 5 1.1 3 0l1.1 1.9L3 3.8l2-1.1zm9.1 7.5-1.9-1.1 1.1 1.9-1.1 2 1.9-1.1L16 13l-1.1-2L16 9.1l-1.9 1.1zM16 0l-1.9 1.1L12.2 0l1.1 1.9-1.1 1.9 1.9-1.1L16 3.8l-1.1-1.9L16 0zm-5.8 4c-.3-.3-.8-.3-1.1 0L.2 12.9c-.3.3-.3.8 0 1.1L2 15.8c.3.3.8.3 1.1 0L12 6.9c.3-.3.3-.8 0-1.1L10.2 4zm-.8 4.2L7.8 6.6l1.9-1.9 1.6 1.6-1.9 1.9z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMagicWand);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
